<app-progress-spinner></app-progress-spinner>
<div class="pointer-events-none fixed inset-x-0 top-3 z-30 flex justify-center px-3 sm:px-4 md:px-6">
  <div class="pointer-events-auto flex max-w-[calc(100vw-1.5rem)] flex-col items-center gap-2 sm:max-w-[calc(100vw-2rem)]">
    <app-pwa-update-prompt />
    <app-pwa-install-prompt />
  </div>
</div>
<router-outlet />
